import { render } from "./AdminButtons.vue?vue&type=template&id=3b468f79"
import script from "./AdminButtons.vue?vue&type=script&lang=ts"
export * from "./AdminButtons.vue?vue&type=script&lang=ts"

import "./AdminButtons.vue?vue&type=style&index=0&id=3b468f79&lang=stylus"
script.render = render

export default script